module.exports = __webpack_public_path__ + "img/gavion.4746bd8c.jpeg";